import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const stages = [
  {
    tag: "01",
    label: "Pause",
    subhead: "Quiet the noise.",
    body:
      "When you don't know what to believe anymore & you'd love ten minutes to get quiet, breathe, and get curious about what's actually happening inside you...start here.",
    ctaLabel: "Pause the Spiral — Free",
    to: "/pause-the-spiral",
    variant: "cream",
  },
  {
    tag: "02",
    label: "Reclaim",
    subhead: "Hear your own voice.",
    body:
      "A private 60-minute Faith & Identity Coaching session for the question, decision, or belief you can't stop circling. Leave with a clarity insight and a practical next step.",
    ctaLabel: "Book Reclaiming You",
    to: "/reclaim",
    variant: "white",
  },
  {
    tag: "03",
    label: "Become",
    subhead: "Create what comes next.",
    body:
      "A private 6-month Faith & Identity Coaching experience for women rebuilding after high-control Christianity. Rebuilding is the work. Becoming is the transformation.",
    ctaLabel: "Explore Become",
    to: "/become",
    variant: "forest",
  },
];

const Pathway = () => (
  <section
    id="pathway"
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="pathway-section"
  >
    <div className="max-w-[1200px] mx-auto px-6 sm:px-10">
      <div className="max-w-3xl mb-12">
        <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-4">The pathway</p>
        <h2
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#4F5D4F] leading-[1.15] tracking-tight"
          data-testid="pathway-headline"
        >
          You don't have to figure it all out at once.
        </h2>
        <p className="mt-5 text-[#4F5D4F]/85 font-light text-lg leading-relaxed">
          There is no deadline for becoming. Wherever you are right now, there's a place to begin.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-5" data-testid="pathway-stages">
        {stages.map((s) => {
          const isForest = s.variant === "forest";
          const isCream = s.variant === "cream";
          const cardBg = isForest
            ? "bg-[#4F5D4F] text-[#F6F1EA] border-[#4F5D4F]"
            : isCream
            ? "bg-[#D7B2A3]/20 text-[#4F5D4F] border-[#D7B2A3]/70"
            : "bg-white text-[#4F5D4F] border-[#D7B2A3]/70";
          const tagColor = isForest ? "text-[#D7B2A3]" : "text-[#B89B63]";
          const subheadColor = isForest ? "text-[#D7B2A3]" : "text-[#B89B63]";
          const bodyColor = isForest ? "text-[#F6F1EA]/85" : "text-[#4F5D4F]/85";
          const btnClass = isForest
            ? "bg-[#F6F1EA] text-[#4F5D4F] hover:bg-[#D7B2A3]"
            : "bg-[#4F5D4F] text-[#F6F1EA] hover:bg-[#3a453a]";

          return (
            <div
              key={s.label}
              className={`border ${cardBg} p-8 flex flex-col`}
              data-testid={`pathway-stage-${s.label.toLowerCase()}`}
            >
              <p className={`text-xs tracking-eyebrow uppercase mb-3 ${tagColor}`}>Stage {s.tag}</p>
              <h3 className="font-serif text-3xl sm:text-4xl tracking-tight uppercase">{s.label}</h3>
              <p className={`font-serif italic text-lg mt-2 ${subheadColor}`}>{s.subhead}</p>
              <p className={`mt-5 font-light leading-relaxed flex-1 ${bodyColor}`}>{s.body}</p>
              <Link
                to={s.to}
                className={`mt-8 group inline-flex items-center justify-center gap-2 px-5 py-3 text-xs tracking-eyebrow uppercase transition-colors ${btnClass}`}
                data-testid={`pathway-cta-${s.label.toLowerCase()}`}
              >
                {s.ctaLabel}
                <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Pathway;
